import { nativeEnum, z } from 'zod'
import { LearningQuestionListSchema, LearningQuestionSchema } from './QuizQuestionSchema.ts'
import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus.ts'

/**
 * Schéma de validation pour une version de quiz d'apprentissage
 */
export const QuizVersionSchema = z.object({
  id: z.number(),

  quizId: z.number(),

  versionNumber: z.number(),

  title: z.string().nullable(),

  comment: z.string().nullable(),

  status: nativeEnum(LearningStatus.Values),

  questions: LearningQuestionListSchema
})

/**
 * Schéma pour la liste des versions d'un quiz
 */
export const QuizVersionListSchema = z.array(QuizVersionSchema)

/**
 * Types TypeScript dérivés des schémas (Entity types)
 */
export type QuizVersionEntity = z.infer<typeof QuizVersionSchema>
export type QuizVersionListEntity = z.infer<typeof QuizVersionListSchema>
